import request from '@/utils/request'

export function getHomeData(params) {
    return request({
      url: '/home/index',
      method: 'get',
      params
    })
  }
  